import { defineRule, configure } from 'vee-validate';
import * as rules from '@vee-validate/rules';
Object.entries(rules).forEach(([ruleName, rule]) => {
    if (typeof rule === 'function') {
        defineRule(ruleName, rule);
    }
});

defineRule('greater_than', (value, [min]) => {
    if (value == null || value === '') return true;
    // remove commas, parse
    const num = Number(String(value).replace(/,/g, ''));
    if (isNaN(num)) return 'Must be a number';
    return num > min || `Must be at greater than ${min}`;
});

defineRule('date_format', (value, [format = 'dd/MM/yyyy']) => {
    if (!value) return true; // Let 'required' handle empty values

    // Normalize format
    const normalizedFormat = format.toLowerCase();

    if (normalizedFormat !== 'dd/mm/yyyy') {
        console.warn(`Only 'dd/MM/yyyy' format is currently supported`);
        return true;
    }

    // Format validation
    if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
        return 'Date must be in DD/MM/YYYY format';
    }

    const [day, month, year] = value.split('/').map(Number);

    // Basic validation
    if (year < 1000 || year > 9999) return 'Year must be between 1000-9999';
    if (month < 1 || month > 12) return 'Month must be between 01-12';

    // Day validation
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
        return `Day must be between 01-${daysInMonth} for ${month}/${year}`;
    }

    // Date validity
    const inputDate = new Date(year, month - 1, day);
    if (inputDate.getFullYear() !== year || inputDate.getMonth() !== month - 1 || inputDate.getDate() !== day) {
        return 'Invalid date';
    }

    // Future date check
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to compare dates only
    if (inputDate > today) {
        return 'Date cannot be in the future';
    }

    return true;
});

configure({
    validateOnInput: true,
    validateOnBlur: true
});
